import { render, staticRenderFns } from "./LeaverHistoryLog.vue?vue&type=template&id=263a0a86&"
import script from "./LeaverHistoryLog.vue?vue&type=script&lang=ts&"
export * from "./LeaverHistoryLog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports